import { useTranslation } from "react-i18next";

type Props = { status?: string | null };

/**
 * Game state. The live dot pulses only while a game is actually running, so
 * "active" is readable at a glance from across a room.
 */
export default function StatusPill({ status }: Props) {
  const { t } = useTranslation();
  const value = (status ?? "lobby").toLowerCase();
  const variant =
    value === "active" ? "active" : value === "ended" ? "ended" : "lobby";

  return (
    <span className={`status status--${variant}`}>
      <span className="status__dot" aria-hidden="true" />
      {t(`status.${variant}`)}
    </span>
  );
}
